import { combineReducers } from 'redux';

import assets, { AssetsStateType } from 'store/assets';
import connection, { ConnectionStateType } from 'store/connection';
import dashboard, { DashboardStateType } from 'store/dashboard';
import events, { EventsStateType } from 'store/events';
import exercises, { ExercisesStateType } from 'store/exercises';
import favorites, { FavoritesStateType } from 'store/favorites';
import layout, { LayoutStateType } from 'store/layout';
import login, { LoginStateType } from 'store/login';
import mySuccess, { MySuccessStateType } from 'store/mySuccess';
import offlineAvailability, { OfflineAvailabilityStateType } from 'store/offlineAvailability';
import optionalProgramItems from 'store/optionalProgramItems';
import pools, { PoolsStateType } from 'store/pools';
import profile, { ProfileStateType } from 'store/profile';
import programDays, { ProgramDaysStateType } from 'store/programDays';
import programItems, { ProgramItemStateType } from 'store/programItems';
import programOverview, { ProgramOverviewStateType } from 'store/programOverview';
import programPreview, { ProgramPreviewStateType } from 'store/programPreview';
import programs, { ProgramsStateType } from 'store/programs';
import recipes, { RecipesStateType } from 'store/recipes';
import router, { RouterStateType } from 'store/router';
import sequences, { SequencesStateType } from 'store/sequences';
import settings, { SettingsStateType } from 'store/settings';
import trackingDescription, { TrackingDescriptionStateType } from 'store/trackingDescription';
import transientPoolState, { TransientPoolStateType } from 'store/transientPoolState';
import translation, { TranslationStateType } from 'store/translation';
import tutorial, { TutorialStateType } from 'store/tutorial';
import view, { ViewStateType } from 'store/view';

export const actionTypes: { FLUSH_ALL_PROGRAM_DATA: string } = {
	FLUSH_ALL_PROGRAM_DATA: 'GLOBAL/FLUSH_ALL_PROGRAM_DATA',
};

export const actionCreators: { doFlushAllProgramData: Function } = {
	doFlushAllProgramData: () => {
		return {
			type: actionTypes.FLUSH_ALL_PROGRAM_DATA,
		};
	},
};

export interface IRootState {
	assets: AssetsStateType;
	connection: ConnectionStateType;
	dashboard: DashboardStateType;
	events: EventsStateType;
	exercises: ExercisesStateType;
	favorites: FavoritesStateType;
	layout: LayoutStateType;
	login: LoginStateType;
	mySuccess: MySuccessStateType;
	offlineAvailability: OfflineAvailabilityStateType;
	pools: PoolsStateType;
	profile: ProfileStateType & SettingsStateType;
	programDays: ProgramDaysStateType;
	programItems: ProgramItemStateType;
	programOverview: ProgramOverviewStateType;
	programPreview: ProgramPreviewStateType;
	programs: ProgramsStateType;
	recipes: RecipesStateType;
	router: RouterStateType;
	sequences?: SequencesStateType;
	trackingDescription: TrackingDescriptionStateType;
	transientPoolState: TransientPoolStateType;
	translation: TranslationStateType;
	tutorial: TutorialStateType;
	view: ViewStateType;
}

export const reducers = {
	assets,
	dashboard,
	login,
	profile,
	favorites,
	programs,
	programDays,
	programItems,
	optionalProgramItems,
	programPreview,
	programOverview,
	view,
	events,
	sequences,
	mySuccess,
	settings,
	exercises,
	router,
	tutorial,
	connection,
	layout,
	translation,
	recipes,
	pools,
	trackingDescription,
	offlineAvailability,
	transientPoolState,
};

// @ts-ignore
export default combineReducers<any>(reducers as any);
